<div class="update-bar">
    <p>{{ 'newVersion' | translate }}</p>

    <div class="buttons-wrapper">
        <button mat-stroked-button color="primary"
                class="refresh-btn"
                (click)="update()">
            <i class="fa-solid fa-arrows-rotate"></i>
            {{ 'refresh' | translate }}
        </button>

        <button mat-stroked-button color="primary"
                class="close-btn"
                (click)="close()">
            <i class="fas fa-times"></i>
        </button>
    </div>
</div>
